import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../components/pages/home/Index.vue";
import ProductList from "../components/pages/product/List.vue";
import ProductItem from "../components/pages/product/Item.vue";
import GalleryList from "../components/pages/gallery/List.vue";
import GalleryItem from "../components/pages/gallery/Item.vue";
import Shops from "../components/pages/Shops.vue";
import Brands from "../components/pages/Brands.vue";
import ContactUs from "../components/pages/ContactUs.vue";
import WorkWithUs from "../components/pages/WorkWithUs.vue";
import Vacancies from "../components/pages/Vacancies.vue";
import Error404 from "../components/pages/Error404.vue";

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "Início",
    component: Home
  },
  {
    path: "/produtos",
    name: "Produtos",
    component: ProductList
  },
  {
    path: "/produtos/:product",
    name: "Produto",
    component: ProductItem
  },
  {
    path: "/lojas",
    name: "Lojas",
    component: Shops
  },
  {
    path: "/galeria",
    name: "Galeria",
    component: GalleryList
  },
  {
    path: "/galeria/:item",
    name: "Galeria",
    component: GalleryItem
  },
  {
    path: "/marcas-parceiras",
    name: "Marcas Parceiras",
    component: Brands
  },
  {
    path: "/contato",
    name: "Contato",
    component: ContactUs
  },
  {
    path: "/trabalhe-conosco",
    name: "Trabalhe Conosco",
    component: WorkWithUs
  },
  {
    path: "/vagas",
    name: "Vagas",
    component: Vacancies
  },
  {
    name: "Error404",
    path: "/error404",
    component: Error404
  },
  {
    path: "*",
    beforeEnter: (to, from, next) => {
      next("/error404");
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;
